import { useState } from "react";
import Classes from "./Services.module.css";
import { useNavigate } from "react-router-dom";

const services = [
    { id: 1, name: "SEO", description: "Comprehensive SEO service for better rankings.", price: 500, type: "one-time" },
    { id: 2, name: "UI/UX", description: "Intuitive UI/UX design for engagement.", price: 500, type: "one-time" },
    { id: 3, name: "Copywriting", description: "Conversion-focused copywriting for impact.", price: 125, type: "monthly" },
];

export default function Services() {
    const [selectedService, setSelectedService] = useState(services[1]); // Default to UI/UX
    const [email, setEmail] = useState("");
    const [termsAccepted, setTermsAccepted] = useState(false);
    const navigateTo = useNavigate();

    return (
        <>
            <div className={Classes.hero}>
                <div className={Classes.header}>
                    <div>
                        <h3>Services</h3>
                        <h5>Pick one of the services and choose your optional add-ons below. <br /> You’ll be asked to provide project detail information after this step.</h5>
                    </div>
                </div>
                <div className={Classes.container}>
                    <div className={Classes.servicesSection}>
                        <h5 className="mb-10" >Pick a service</h5>
                        <div className={Classes.services}>
                            {services.map((service) => (
                                <div
                                    key={service.id}
                                    className={`${Classes.serviceCard} ${selectedService.id === service.id ? Classes.selected : ""}`}
                                    onClick={() => setSelectedService(service)}
                                >
                                    <h3>{service.name}</h3>
                                    <p>{service.description}</p>
                                    <h5 className={Classes.price}>${service.price}/{service.type}</h5>
                                </div>
                            ))}
                        </div>

                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Service name</label>
                            <input
                                type="email"
                                className={Classes.inputField}
                                placeholder="email@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className={Classes.option}>
                            <input
                                type="checkbox"
                            />
                            <div>
                                <label htmlFor="check1" >
                                    <h5>Assign to a team member</h5>
                                    <p>Assign orders of this service to a team member.</p>
                                </label>
                            </div>
                        </div>

                        <button className={Classes.button} onClick={() => { navigateTo('/project-details') }}>
                            <h5>Go to Project Details</h5>
                        </button>
                    </div>

                    <div className={Classes.summarySection}>
                        <div className={Classes.header}>
                            <div>
                                <h3>Summary</h3>
                            </div>
                        </div>
                        <p className={Classes.summaryItem}>
                            <h5>{selectedService.name}</h5>
                            <h5>${selectedService.price}.00</h5>
                        </p>
                        <p className={Classes.lightText} >Qty 1</p>

                        <input className={Classes.coupon} type="text" placeholder="Have a coupon?" disabled />

                        <p className={Classes.total}>
                            <div>
                                <h5>Total</h5>
                                <p className={Classes.lightText} >USD</p>
                            </div>
                            <div>
                                <span>${selectedService.price}.00</span>
                                <p className={Classes.lightText} style={{ textAlign: 'end' }} >One time</p>
                            </div>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
